import { USERS_REQUEST,
  USERS_SUCCESS,
  USERS_EMPTY,
  USERS_ERROR,
  USERS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL,
  USERS_REQUEST_COMMITTEE_USERS,
  USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS,
  USERS_IMPORT,
  USERS_IMPORT_CHECK,
  USERS_SET_QUERY,
  } from '../actions/users'

import { UserRoles } from '@/lib/userRoles'
import Api from '@/services/Api'

const state = {
  status: '',
  users_query: localStorage.getItem('users.usersQuery')?localStorage.getItem('users.usersQuery'):'',
  current_page: 1,
}

const getters = {
  getCurrentPage: state => state.current_page,
}

const actions = {
  [USERS_REQUEST]: ({commit, state}, page) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)

      Api().get('/users', {
          params: {
            page : page,
            query : state.users_query
          }
        })
      .then(function (response) {
        commit(USERS_SUCCESS, response);
        resolve(response);
      })
      .catch(function (error) {
        commit(USERS_ERROR);
        reject(error);
      });
    });
  },

  [USERS_REQUEST_GUIDELINES_AND_PUBLICATION_COUNCIL]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)
      Api().get('/users', {
          params: {
            role : UserRoles.guidelinesAndPublicationsCouncil
          }
        })
        .then(function (response) {
          commit(USERS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USERS_ERROR);
          reject(error);
        });
    });
  },

  [USERS_REQUEST_COMMITTEE_USERS]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)
      Api().get('/users', {
          params: {
            role : UserRoles.committeeUser
          }
        })
        .then(function (response) {
          commit(USERS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USERS_ERROR);
          reject(error);
        });
    });
  },

  [USERS_REQUEST_COMMITTEE_AND_EXTERNAL_USERS]: ({commit}) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)
      Api().get('/users', {
          params: {
            role : [UserRoles.committeeUser, UserRoles.external]
          }
        })
        .then(function (response) {
          commit(USERS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USERS_ERROR);
          reject(error);
        });
    });
  },

  [USERS_IMPORT]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)
      Api().post('/users-import', args)
        .then(function (response) {
          commit(USERS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USERS_ERROR);
          reject(error);
        });
    });
  },

  [USERS_IMPORT_CHECK]: ({commit}, args) => {
    return new Promise((resolve, reject) => {
      commit(USERS_REQUEST)
      Api().get('/users-import-check')
        .then(function (response) {
          commit(USERS_SUCCESS);
          resolve(response);
        })
        .catch(function (error) {
          commit(USERS_ERROR);
          reject(error);
        });
    });
  },
};

const mutations = {
  [USERS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [USERS_SET_QUERY]: (state, payload) => {
    localStorage.setItem('users.usersQuery', payload);
    state.users_query = payload;
  },

  [USERS_SUCCESS]: (state, response) => {
    state.status = 'success';

    if (response != undefined) {
      state.current_page = response.data.meta.current_page;
    }
  },
  [USERS_EMPTY]: (state) => {
    state.status = 'empty';
  },
  [USERS_ERROR]: (state) => {
    state.status = 'error';
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
